import React from 'react';

import BlackBox from 'Core/Components/BlackBox';
import ContactBlock from 'Core/Components/ContactBlock';

class ContactList extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { list, className } = this.props;
    return (
      <div className={'row ContactList' + (className ? ' ' + className : '')}>
        {!list ? null : list.map((contact, idx) => {
          let Container = (contact.primary && false ? BlackBox : 'box');
          return (
            <Container key={idx} className={`ContactBlock-Wrapper ${list.length === 4 ? 'has-four' : ''}`}>
              <ContactBlock key={contact.name} contact={contact} list={list} />
            </Container>
          );
        })}
      </div>
    );
  }
};

export default ContactList;



// WEBPACK FOOTER //
// ./client/Core/Components/ContactList.jsx